import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import PhoneImg from '../../../../../../../assets/phone.svg'
import './Phone.scss'

const Phone = ({ number, numberDisplay, isLink, phoneClick }) => (
  <Fragment>
    <div className="phone-icon">
      {isLink && (
        <a
          className="phone-link"
          href={`tel:${number}`}
          onClick={phoneClick}
        >
          <img
            alt="Phone"
            src={PhoneImg}
          />
        </a>
      )}
      {!isLink && (
        <img
          alt="Phone"
          src={PhoneImg}
        />
      )}
    </div>
    <div className="phone-number">
      {numberDisplay}
    </div>
  </Fragment>
)

Phone.defaultProps = {
  number: '',
  numberDisplay: '',
  isLink: false
}

Phone.propTypes = {
  number: PropTypes.string,
  numberDisplay: PropTypes.string,
  isLink: PropTypes.bool,
  phoneClick: PropTypes.func
}

export default Phone
